import { BrowserModule } from '@angular/platform-browser';
import { Component } from '@angular/core';

@Component({
    selector: 'layout-compoenent',
    templateUrl: './layout.component.html'
})

export class LayoutComponent {}



// WEBPACK FOOTER //
// /home/xpro/Documentos/ances/myjangular/src/app/layout/layout.component.ts